import {
  IProductclusterProductgroep,
  IProductgroepenReport,
} from 'src/common/services/client'

export const byExistingCodeFilter =
  (productgroepen: IProductclusterProductgroep[]) =>
  (entry: IProductgroepenReport): boolean =>
    !productgroepen.find(ppg => entry.productGroepCode === ppg.productgroepCode)
